export var IMAGE_MODE_FLAG = 1;
export var COLOR_MODE_FLAG = 2;
export var GRADIENT_MODE_FLAG = 4;
//# sourceMappingURL=mode.js.map